// extracted by mini-css-extract-plugin
module.exports = {"FrontEndSkills":"ShowSkill_FrontEndSkills__2UtPo","Title":"ShowSkill_Title__2RUiW","Icon":"ShowSkill_Icon__2PNjq"};